import settings from "../settings";

const apiCall = async (apiMsg) => {
  try {
    const response = await fetch(settings.apiUrl + "/api/index.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(apiMsg),
    });

    if (!response.ok) {
      return { error: 1, msg: "The API request failed!" };
    }

    const jsonResponse = await response.json();

    if (jsonResponse.error !== 0) {
      if (jsonResponse.error === 99) {
        return { error: 99, msg: "Session ended" };
      } else {
        return { error: 1, msg: jsonResponse.msg };
      }
    }

    return jsonResponse;
  } catch (e) {
    return { error: 1, msg: "The API request failed!" };
  }
};

export default apiCall;
